module.exports = __webpack_public_path__ + "static/media/enagic-img2.8b8cdfa4.png";